import { Icon } from '@atom/mui';
import { GroupIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { getColorFromColorId } from '@atom/utilities/colorUtilities';

interface Props {
  colorId?: number;
  disabled?: boolean;
  size?: number;
}

const ICON_SCALE = 0.65;

const styles = {
  icon: {
    fontSize: '22px',
    color: colors.neutral.white,
    fontWeight: '500',
  },
  iconContainer: {
    width: '34px',
    height: '34px',
    borderRadius: '50%',
    backgroundColor: colors.neutral.gray,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const UserGroupIcon = ({ colorId, disabled, size }: Props) => {
  const color = getColorFromColorId(colorId);

  const containerSize = size && {
    width: `${size}rem`,
    height: `${size}rem`,
    flexShrink: 0,
  };

  const iconSize = size && { fontSize: `${size * ICON_SCALE}rem` };

  return (
    <div
      style={{
        ...styles.iconContainer,
        ...containerSize,
        backgroundColor: color,
        opacity: disabled ? '0.5' : '1',
      }}
    >
      <Icon style={{ ...styles.icon, ...iconSize }} icon={GroupIcon} />
    </div>
  );
};

export default UserGroupIcon;
